<template>
  <div>
    <v-slide-group show-arrows class="mt-5">
      <v-slide-item v-for="(item, i) in list" :key="i">
        <v-card class="mr-2" outlined>
          <v-list-item>
            <v-list-item-avatar>
              <image-view :src="getURL(item)"></image-view>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ServiceName }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-bold black-text mt-1">
                {{
                  item.Flat == "True" ? `Rs ${item.Offer}` : `${item.Offer}%`
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<script>
import { getURL } from "../../assets/js/common";
import ImageView from "../ImageView.vue";
export default {
  components: { ImageView },
  computed: {
    dashboard() {
      return this.$store.getters.dashboard;
    },
    list() {
      let { Commission } = this.dashboard;
      let list = [];
      if (Commission instanceof Array) {
        Commission.forEach((item) => {
          list = list.concat(item.data);
        });
      }
      return list;
    },
  },
  methods: {
    getURL({ Circle_img_path }) {
      return getURL(Circle_img_path);
    },
  },
};
</script>

<style>
</style>